"use strict";

var _taggedTemplateLiteral = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.descriptionTitle = void 0;

var _core = require("@emotion/core");

var _utilities = require("../../utilities");

var descriptionTitle = function descriptionTitle(_ref) {
  var theme = _ref.theme;
  return (0, _core.css)(_templateObject(), _utilities.utilities.typography.h6(theme));
};

exports.descriptionTitle = descriptionTitle;